import { useCallback, useEffect } from 'react';

const useReSizePrimeDelivery = (
  primeDeliveryTextWrapRef: React.RefObject<HTMLDivElement>,
  onVisibleChange: (visible: boolean) => void
) => {
  const handlePrimeDeliveryTextWrapResize = useCallback(() => {
    if (!primeDeliveryTextWrapRef.current) return null;

    // 设置超时逻辑
    const timer: number | undefined = window.setTimeout(() => {
      try {
        onVisibleChange(false);
      } catch (error) {
        console.error('onVisibleChange error:', error); // 捕获异常
      }
      if (resizeObserver) {
        resizeObserver.disconnect(); // 停止观察
      }
    }, 5000);

    const resizeObserver = new ResizeObserver((entries) => {
      try {
        entries.forEach((entry) => {
          // 如果高度大于0，则认为有Prime
          if (entry.contentRect.height > 0) {
            onVisibleChange(true);
            if (timer) {
              clearTimeout(timer); // 清除定时器
            }
            resizeObserver.disconnect(); // 停止观察
          }
        });
      } catch (error) {
        console.error('ResizeObserver error:', error); // 捕获异常
      }
    });

    try {
      resizeObserver.observe(primeDeliveryTextWrapRef.current); // 开始观察
    } catch (error) {
      console.error('Failed to observe element:', error); // 捕获异常
    }

    return resizeObserver;
  }, []);

  useEffect(() => {
    const resizeObserver = handlePrimeDeliveryTextWrapResize();

    return () => {
      try {
        if (resizeObserver) {
          resizeObserver.disconnect(); // 清理观察器
        }
      } catch (error) {
        console.error('Failed to disconnect ResizeObserver:', error); // 捕获异常
      }
    };
  }, []);
};

export default useReSizePrimeDelivery;
